import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { FC, ReactNode, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { FadeInModalContext } from '@/components/layouts/fadeInModalContext';
import { SignUpContext, SignUpSteps } from '@/containers/SignUp/components/SignUpContext';
import { OverlayType } from '@/enums';
import { AccessFrom } from '@/enums/AccessFrom';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

const LogInLink: FC<{ children?: ReactNode }> = ({ children }) => {
  const { accessFrom = AccessFrom.Core } = useQueryParams<{ accessFrom: AccessFrom }>({
    accessFrom: StringParam,
  });

  return (
    <Link href={`/log-in?accessFrom=${accessFrom}`} legacyBehavior>
      <Button color="black" variant="link" type="button">
        {children}
      </Button>
    </Link>
  );
};

export const FailureStep = () => {
  const { t } = useTranslation();
  const { showModalType } = useContext(FadeInModalContext);
  const { setSignUpProps, setCurrentStep } = useContext(SignUpContext);

  const handleTryAgain = () => {
    setSignUpProps({});
    setCurrentStep(SignUpSteps.BASIC_INFO);
  };

  return (
    <Flex w="full" justifyContent="space-around" flexDirection={{ base: 'column', lg: 'row' }}>
      <Flex mb={14} maxW="390px" flexDirection="column" flex={1}>
        <Text color="gray.600">{`3 / 3`}</Text>
        <Heading mt={8} fontSize="5xl">
          {t('createAccount.failure.title')}
        </Heading>

        <Trans
          i18nKey="createAccount.failure.message"
          components={{
            text: <Text mt={12} mb={14} color="gray.600" />,
            hyperlink: <LogInLink />,
            button: (
              <Button
                variant="link"
                color="black"
                onClick={() => showModalType.set(OverlayType.RESET_PASSWORD)}
                type="button"
              />
            ),
          }}
        />
        <Button alignSelf="flex-start" variant="outline" onClick={handleTryAgain}>
          {t('action.tryAgain')}
        </Button>
      </Flex>
      <Flex flexDirection="column" maxW="390px" flex={1}></Flex>
    </Flex>
  );
};
